import React, { useState } from "react";
import { useStores } from "_common/hooks";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import HeaderTop from "_common/component/Layout/Header/HeaderTop";
import i18next from "i18next";

export default function Recharge() {
  const navigate = useNavigate();
  const {
    authStore: { partners, banks, setBankDeposit },
  } = useStores();

  const [rechargeType, setRechargeType] = useState(2);

  return (
    <div className="bg-black min-h-screen mt-[70px]">
      <HeaderTop title={i18next.t("deposit")} />
      <div className="flex flex-col gap-4 p-4">
        <h2 className="text-[32px] text-white font-bold text-center">
          {i18next.t("select_deposit")}
        </h2>
        <Link
          className="flex py-[6px] gap-2 bg-[#202125] px-4 rounded"
          to="/cskh"
        >
          <svg
            focusable="false"
            aria-hidden="true"
            viewBox="0 0 24 24"
            width="48"
            height="48"
            data-testid="SupportAgentIcon"
          >
            <path
              d="M21 12.22C21 6.73 16.74 3 12 3c-4.69 0-9 3.65-9 9.28-.6.34-1 .98-1 1.72v2c0 1.1.9 2 2 2h1v-6.1c0-3.87 3.13-7 7-7s7 3.13 7 7V19h-8v2h8c1.1 0 2-.9 2-2v-1.22c.59-.31 1-.92 1-1.64v-2.3c0-.7-.41-1.31-1-1.62"
              fill="#fff"
            />
            <circle cx="9" cy="13" r="1" fill="#fff" />
            <circle cx="15" cy="13" r="1" fill="#fff" />
            <path
              d="M18 11.03C17.52 8.18 15.04 6 12.05 6c-3.03 0-6.29 2.51-6.03 6.45 2.47-1.01 4.33-3.21 4.86-5.89 1.31 2.63 4 4.44 7.12 4.47"
              fill="#3d5afe"
            />
          </svg>
          <div className="flex flex-col text-sm text-white">
            <span className="text-lg font-semibold">{i18next.t("note1")}</span>
            <span className="text-md">{i18next.t("note2")}</span>
          </div>
        </Link>
      </div>
    </div>
  );
}
